import { Box, useTheme } from '@/ui/primitives';
import { resolveChartPlotAreaBackgroundColor } from '@/ui/primitives/chartPlotAreaBackgroundColor';
import type { ReactElement } from 'react';

type CoverageTimelineChartSkeletonProps = {
  height: number;
};

export const CoverageTimelineChartSkeleton = ({
  height,
}: CoverageTimelineChartSkeletonProps): ReactElement => {
  const theme = useTheme();
  const plotAreaBackgroundColor = resolveChartPlotAreaBackgroundColor(theme);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: `${height}px`,
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: '40px',
          right: '20px',
          top: '16px',
          bottom: '36px',
          backgroundColor: plotAreaBackgroundColor,
          boxShadow: [
            `inset 1px 0 0 ${theme.app.colors.divider}`,
            `inset -1px 0 0 ${theme.app.colors.divider}`,
            `inset 0 1px 0 ${theme.app.colors.divider}`,
            `inset 0 -1px 0 ${theme.app.colors.divider}`,
          ].join(', '),
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: '50%',
            height: '1px',
            backgroundColor: theme.app.colors.divider,
            opacity: 0.4,
          }}
        />
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <path
            d="M 0 62 C 12 61.5, 24 61, 36 61 C 48 60.8, 60 60.4, 72 60 C 84 59.6, 92 59.2, 100 58.5"
            fill="none"
            stroke={theme.app.colors.border}
            strokeWidth={1.4}
            strokeLinecap="round"
            strokeLinejoin="round"
            opacity="0.9"
          />
        </svg>
      </Box>
    </Box>
  );
};
